export const CREATE_ONBOARDING_THIRD_STEP_DATA_BEGIN = 'CREATE_ONBOARDING_THIRD_STEP_DATA_BEGIN'
export const CREATE_ONBOARDING_THIRD_STEP_DATA_SUCCESS = 'CREATE_ONBOARDING_THIRD_STEP_DATA_SUCCESS'
export const CREATE_ONBOARDING_THIRD_STEP_DATA_ERROR = 'CREATE_ONBOARDING_THIRD_STEP_DATA_ERROR'

export const GET_ONBOARDING_THIRD_STEP_DATA_BEGIN = 'GET_ONBOARDING_THIRD_STEP_DATA_BEGIN'
export const GET_ONBOARDING_THIRD_STEP_DATA_SUCCESS = 'GET_ONBOARDING_THIRD_STEP_DATA_SUCCESS'
export const GET_ONBOARDING_THIRD_STEP_DATA_ERROR = 'GET_ONBOARDING_THIRD_STEP_DATA_ERROR'

export const GET_COMPANIES_BEGIN = "GET_COMPANIES_BEGIN";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_ERROR = "GET_COMPANIES_ERROR";

export const UPDATE_COMPANY_BEGIN = "UPDATE_COMPANY_BEGIN";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_ERROR = "UPDATE_COMPANY_ERROR";

export const DELETE_COMPANY_BEGIN = "DELETE_COMPANY_BEGIN";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_ERROR = "DELETE_COMPANY_ERROR";